export const DASHBOARD_SLUG_WAREHOUSE = 'warehouse';
export const DASHBOARD_SLUG_SALES_REP = 'sales-rep';
export const DASHBOARD_SLUG_SALES_REP_REG = 'sales-rep-reg';
